
import {Component, Prop,  Vue} from 'vue-property-decorator';
import {EntityChoice} from '@/lib/EntityChoice';

@Component({})
export default class EntityField extends Vue {
    public search: string = '';
    public choicesOpen: boolean = false;
    public debounce: number = 0;
    public scrollDebounce: number = 0;
    public page = 1;
    public max = 0;
    public count = 0;
    public canScroll = true;
    public total = 0;
    public value = '';
    public valueId = '';
    @Prop() public rawChoiceList: any;
    public displayedChoices: Array<EntityChoice> = [];
    public choices: any = [];
    @Prop() public initialValue: any;

    public openChoices() {
        this.choicesOpen = true;
    }


    public closeChoices(immediately: boolean) {
        if(immediately){
            this.choicesOpen = false;
        }else{
            setTimeout(() => {
                this.choicesOpen = false;
            }, 250);
        }

    }

    public scroll(event: any) {
        clearTimeout(this.scrollDebounce);
        this.scrollDebounce = setTimeout(() => {
            const target = event.target;
            const toScroll = target.scrollHeight - (target.scrollTop + target.clientHeight);
            if (toScroll < 15) {
                this.updateField(true);
            }
        }, 250);
    }

    public toggleChoices() {
        this.choicesOpen = !this.choicesOpen;
    }
    public clearResponse(){
      this.value = '';
      this.valueId = '';
      this.openChoices();
      this.updateField();

    }
    public blur(event: any){
        this.closeChoices(false);
    }

    public mounted() {
        this.rawChoiceList.forEach((choice: any) => {
            const entityChoice = new EntityChoice(choice.id, choice.label);
            this.choices.push(entityChoice);
            if (choice.id + "" == this.initialValue) {
                this.updateAnswer(entityChoice);
            }
        });
    }

    public updateField(paginate = false) {

        clearTimeout(this.debounce);
        this.debounce = setTimeout(
                () => {
                    if(paginate){
                        this.page++;
                    }else{
                        this.page = 1;
                    }
                    this.displayedChoices = [];
                    const max = 10;

                    let occurrences = 0;
                    for (let index in this.choices) {
                        const key = parseInt(index);
                        const choice =  this.choices[key];

                        if(choice.value.toLowerCase().indexOf(this.value.toLowerCase()) !== -1){
                            this.displayedChoices.push(choice);
                            occurrences++;
                        }
                        if( occurrences >= max * this.page){
                            break;
                        }
                    }
                },
                500
        )

    }

    public updateAnswer(choice: EntityChoice) {
        this.value = choice.value;
        this.valueId = choice.id + "";
        const event = document.createEvent('HTMLEvents');
        this.closeChoices(true);
        event.initEvent('blur', true, true);
        this.$refs.input.dispatchEvent(event);
        this.$emit("change", this.rawChoiceList.find((choice: any) => choice.id + "" == this.valueId));
    }
}
